import React, {Component} from 'react';
import {NavBar, Tabs} from 'antd-mobile';
import Before from './Before';
import Now from './Now';
import './style.less';
import {connect} from "react-redux";

let numIndex = 0;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class DataStatistics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: [
                {title: '本期账单'},
                {title: '上期账单'},
            ],
        };
    }

    componentDidMount() {

    }

    onChange = (tab, index) => {
        numIndex = index;
    };

    render() {
        return (
            <div className="dataStatistics">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}/>}
                >数据统计</NavBar>
                <Tabs
                    tabs={this.state.tabs}
                    onChange={(tab, index) => this.onChange(tab, index)}
                    initialPage={numIndex}
                    useOnPan={false}
                    swipeable={false}
                    animated={true}
                    prerenderingSiblingsNumber={false}
                >
                    <Now {...this.props} />
                    <Before {...this.props} />
                </Tabs>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Home/Index/DataStatistics/index.js